import * as React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { IconMaterial } from "./IconMaterial";
import { useSDK } from "../shared/useSDK";
import {
  Breadcrumb,
  BreadcrumbAligner,
  BreadcrumbLink,
} from "./lib/Breadcrumb";

const listLink = {
  to: "/materials",
  text: "Materials",
  icon: <IconMaterial />,
};

export function BreadcrumbMaterial() {
  const params = useParams<{ uuid?: string }>();
  return (
    <BreadcrumbAligner>
      <Breadcrumb>
        <BreadcrumbLink to={listLink.to}>
          {listLink.icon}
          <span>{listLink.text}</span>
        </BreadcrumbLink>
        {params.uuid ? <BreadcrumbItem /> : null}
      </Breadcrumb>
    </BreadcrumbAligner>
  );
}

function BreadcrumbItem() {
  const params = useParams<{ uuid: string }>();
  const { sdk } = useSDK();
  const result = useQuery(["material", params.uuid], (key, uuid: string) =>
    sdk.getMaterial({ materialUuid: uuid })
  );
  const to = `/materials/${params.uuid}`;
  const fallbackText = "Material";
  if (result.status === "loading") {
    return null;
  }
  if (result.status === "error" || result.data === undefined) {
    return <BreadcrumbLink to={to}>{fallbackText}</BreadcrumbLink>;
  }
  return <BreadcrumbLink to={to}>{result.data.data.name}</BreadcrumbLink>;
}
